module.exports = __webpack_public_path__ + "media/assets/avia/search/plane-e64decf386fcb1f8a91242871240a623.png";